import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8vpa7bbq6h: FaireBrandEntity = {
  token: "b_8vpa7bbq6h",
  type: "brand",
  name: "VERY J",
  avatarUrl:
    "https://cdn.faire.com/fastly/5db9efc016f0b272ec7f761e6facd8cbbc083d6700435023b324b084c8d208ae.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9577b302eeee8238f296490893a1bb10be2a9eb9981968c41d1f9a0ce08c4383.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5db9efc016f0b272ec7f761e6facd8cbbc083d6700435023b324b084c8d208ae.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9577b302eeee8238f296490893a1bb10be2a9eb9981968c41d1f9a0ce08c4383.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 80,
  rating: 4.8,
  reviewCount: 858,
  isTopShop: true,
  isInsider: true,
  description:
    "Very J brand targets young contemporary people in their 20s and 30s looking for a street fashion casual brand. \nSince 2009, VERYJ has been committed to providing customers with the best service possible. Very J mainly focuses on modern and trendy styles such as a casual and chic look instead of fancy design or patterns.\nVery J's featured items are easily accessible for anyone to wear, and they give a modernized and comfortable vibe.\nWe are not just following the Fashion Trends. \nOur Designers are inspired to create New Fashion Trends. \nWe grasp the colorful and glamorous lifestyle of the Los Angeles tradition by exposing the couture day by day, and express a variation of surprise in each design.\n\nVERY J DESIGNS,\nNEW TRENDS\n\nCall US: ([redacted-phone]\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:26.470Z",
    importedBy: "entity-db-cli",
  },
};
